import React from 'react';

/**
 * 目標達成の状況（人数ブロック。管理者のみ）。できてる／もう少し／要フォロー／目標未設定。
 * 判定できる日数に満たない間は、「目標未設定 N名」と、判定が始まる目安の文言だけを出す。
 * model = utils/storeView.bucketsModel の結果。タップで管理者タブのスタイリスト一覧へ。
 */
export default function StorePeopleBlock({ model, onOpenRoster }) {
  if (!model) return null;
  return (
    <section className="sv-card" aria-label="目標達成の状況">
      <div className="sv-sec">
        <h2>目標達成の状況</h2>
        {onOpenRoster && (
          <button type="button" className="sv-more" onClick={onOpenRoster}>
            スタイリスト一覧 ›
          </button>
        )}
      </div>
      <div className="sv-ppl">
        {model.items.map((item) => (
          <button
            type="button"
            key={item.key}
            className={`sv-pp sv-pp--${item.key === 'unset' ? 'none' : item.key}`}
            onClick={onOpenRoster}
            disabled={!onOpenRoster}
          >
            <span className="sv-pp-n">
              {item.n}
              <small>名</small>
            </span>
            <span className="sv-pp-l">{item.label}</span>
          </button>
        ))}
      </div>
      {model.note && <div className="sv-cap">{model.note}</div>}
    </section>
  );
}
